import { usePlainStateFormUtils } from "@/components/input/usePlainStateFormUtils";
import { EncryptMappingStatus, FieldMappingInput, FieldMappingResponseDto } from "@/gen/api/governance";
import { FieldMappingCatagory } from "@/pages/obfuscation/mutateEncryptionMappingsController";
import { CommandActionProtocol } from "@/utils/zustand-form/ext/commandAction";
import { FormState } from "@/utils/zustand-form/types";


export const E_FieldMapping = {
  ClssChange: 'classification_change',
  Reset: 'reset',
  EncryptMappingStatusChange: 'encrypt_mapping_status_change',
  MergeDelta: 'merge_delta',
  QueryTouched: 'query_touched',

  CurrTableChanged: 'curr_table_changed',

} as const

export type E_FieldMapping = typeof E_FieldMapping[keyof typeof E_FieldMapping]

export interface ET_FieldMapping {
  [E_FieldMapping.ClssChange]: FieldMpClssChange;
  [E_FieldMapping.Reset]: FieldReset;
  [E_FieldMapping.EncryptMappingStatusChange]: FieldEncryptMappingStatusChange[];
  [E_FieldMapping.QueryTouched]: FieldQueryTouched;
  [E_FieldMapping.CurrTableChanged]: FieldCurrTableChanged;
}

interface FieldMpClssChange {
  fieldId: number;
  c_0: any;
  c_1: any;
}
interface FieldReset {}
interface FieldEncryptMappingStatusChange {
  fieldId: number;
  fromCata: FieldMappingCatagory;
  toCata: FieldMappingCatagory;
}
interface FieldQueryTouched {
  resolve: (thereIsEdit: boolean)=>void;
}
interface FieldCurrTableChanged {
  tableId_0: number;
  tableId_1: number;
}

export const cmd_ResetProtocol = CommandActionProtocol.create('reset')


export const emsChangePayload = (fieldDto: FieldMappingResponseDto, x: FieldMappingInput) => {
  const fromCata = 
      fieldDto.encryptMappingStatus === EncryptMappingStatus.PendingReview ? 'pending-review'
    : fieldDto.encryptMappingStatus === EncryptMappingStatus.Skipped ? 'skip'
    : 'mapped'
  const toCata = 
      x.isSkipped ? 'skip'
    : x.encryptionRuleId ? 'mapped'
    : 'pending-review'
  return {
    fieldId: fieldDto.fieldId!,
    fromCata,
    toCata,
  } as FieldEncryptMappingStatusChange
}

interface Cvr {
  C?: boolean;
  E?: boolean;
  M?: boolean;
}
export const couplingValidationRequest = (states: FormState<FieldMappingInput, FieldMappingResponseDto>|undefined) => {
  const cvr : Cvr = {}
  if (!states) return cvr;
  if (states.touched.secondaryClassificationId) {
    if (states.stage.primaryClassification) { // selected a non-public classification
      cvr.E = true
      cvr.M = true
    }
  }
  if (states.touched.encryptionRuleId) {
    cvr.C = true
    cvr.M = true
  }
  if (states.touched.maskingRule) {
    cvr.C = true
    cvr.E = true
  }
  return cvr
}
export const adjustErrorHelperText = (
  states: FormState<FieldMappingInput, FieldMappingResponseDto>,
  field: keyof FieldMappingInput,
  fieldProps: ReturnType<(typeof usePlainStateFormUtils<FormState<FieldMappingInput, FieldMappingResponseDto>>)>['fieldProps'],
  shouldAdjust: boolean|undefined
) => {
  const fprops = fieldProps(field)
  const fpropsError = !!states.errors[field] && (fprops.error || shouldAdjust)
  const fpropsHelperText = fpropsError ? states.errors[field] : undefined
  return {
    error: fpropsError,
    helperText: fpropsHelperText,
  }
}
